module.exports = __webpack_public_path__ + "static/media/S (13).f2a99f7f.jpg";